module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentView) ? _c('main', {
    class: ['view', ("view--" + (_vm.tools.currentView.key))]
  }, [(_vm.showView('basic-view')) ? _c('basic-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "basic"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('pane-view')) ? _c('pane-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "pane-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('orders-view')) ? _c('orders-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "orders-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('packages-view')) ? _c('packages-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "packages-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('instances-view')) ? _c('instances-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "instances-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('items-view')) ? _c('items-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "items-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('users-view')) ? _c('users-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "users-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('pane-full-view')) ? _c('pane-full-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "pane-full-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('show-all-view')) ? _c('show-all-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "show-all-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('loans-view')) ? _c('loans-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "loans-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('loan-details-view')) ? _c('loan-details-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "loan-details-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('fees-view')) ? _c('fees-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "fees-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('fee-details-view')) ? _c('fee-details-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "fee-details-view"
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b9d336f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewContainer.vue
// module id = 429
// module chunks = 1